import {Component, Type, ViewChild} from '@angular/core';
import {AbstractApplicationFlowComponent} from '../application-flow/abstract-application-flow.component';
import {LoanApplicationFlowNavigator} from '../application-flow/loan-application-flow.navigator';
import {Step} from '../application-flow/steps/step';
import {BankDetailStep} from '../application-flow/steps/bank-details.step';
import {BankDetailsByIfscComponent} from '../bank-details/bank-details-by-ifsc/bank-details-by-ifsc.component';
import {ActivatedRoute, Router} from '@angular/router';
import {BankAccount} from '../model/bank-account';
import {BankDetailsByNameComponent} from '../bank-details/bank-details-by-name/bank-details-by-name.component';
import {BankDetailsComponent} from '../bank-details/bank-details.component';
import {ConfirmPopUpComponent} from '../comfirm-pop-up/confirm-pop-up.component';
import {StorageService} from '../service/storage.service';
import {MatDialog} from '@angular/material';
import {ConfigService} from '../service/config.service';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';

export enum SearchBy {
    Ifsc = 'ifsc',
    BankName = 'bankname'
}

// TODO: Add to loanApplication
@Component({
    templateUrl: './borrower-bank-details.component.html',
    styleUrls: ['./borrower-bank-details.component.css', '../loan-application-flow-component/application-flow.css']
})
export class BorrowerBankDetailsComponent extends AbstractApplicationFlowComponent {
    searchBy: SearchBy;
    public bankAccount: BankAccount;
    loaderStatus = new LoaderStatus();

    @ViewChild(BankDetailsByIfscComponent)
    protected bankDetailsByIfscComponent: BankDetailsByIfscComponent;

    @ViewChild(BankDetailsByNameComponent)
    protected bankDetailsByNameComponent: BankDetailsByNameComponent;
    private storageService: StorageService;
    private router: Router;
    public dialog: MatDialog;
    private configService: ConfigService;

    constructor(private activatedRoute: ActivatedRoute, loanApplicationFlowNavigator: LoanApplicationFlowNavigator, storageService: StorageService, router: Router, dialog: MatDialog, configService: ConfigService) {
        super(loanApplicationFlowNavigator);
        this.storageService = storageService;
        this.router = router;
        this.dialog = dialog;
        this.configService = configService;
        this.activatedRoute.data.subscribe((data) => {
                this.bankAccount = data.bankAccount;
            }
        );

        this.searchBy = SearchBy.Ifsc;
    }

    step(): Type<Step> {
        return BankDetailStep;
    }

    async onSubmit(): Promise<void> {
        let bankDetails: BankDetailsComponent;
        if (this.searchBy === SearchBy.Ifsc) {
            bankDetails = this.bankDetailsByIfscComponent;
        } else {
            bankDetails = this.bankDetailsByNameComponent;
        }
        if (!bankDetails.isValid()) {
            return;
        }

        if (!this.isEnachSupportedBank(bankDetails.searchBankFormGroup.controls.bankName.value)) {
            this.showBankDoesNotSupportEnachPopUp();
        } else {
            this.showEnachInformationPopUpAndSubmit(bankDetails);
        }
    }

    onConfirmResultReceived(result: boolean): void {
        if (!result) {
            this.storageService.clear();
            this.storageService.clearSessionStorage();
            this.router.navigate(['/']);
        }
    }

    onTabChange(tabIndex: number) {
        this.searchBy = (tabIndex === 0 ? SearchBy.Ifsc : SearchBy.BankName);
    }

    private showEnachInformationPopUpAndSubmit(bankDetails: BankDetailsComponent) {
        this.dialog.open(ConfirmPopUpComponent, {
            data: {
                title: 'Ensure that you have NetBanking / Debit Card facility ',
                message: 'Post loan approval, we will be registering the eNACH for EMI collection on the bank account you have provided. Please ensure that you have NetBanking / Debit Card facility activated for this bank account.',
                positiveButtonText: 'Continue'
            },
        }).afterClosed().subscribe(result => {
            if (result) {
                this.proceedWithSubmission(bankDetails);
            }
        });
    }

    private showBankDoesNotSupportEnachPopUp() {
        this.dialog.open(ConfirmPopUpComponent, {
            data: {
                title: 'Selected Bank Currently Not Supported',
                message: 'The bank you have selected does not support registering of eNACH for EMI collection. Please write to us on support@finzy.com for further details.',
                positiveButtonText: 'Go back to my application',
                negativeButtonText: 'I understand, Log me out'
            },
        }).afterClosed().subscribe(result => this.onConfirmResultReceived(result));
    }

    private async proceedWithSubmission(bankDetails: BankDetailsComponent) {
        await executeWithLoader(this.loaderStatus, async () => {
            await bankDetails.saveBankDetails();
            await this.nextPage();
        });
    }

    private isEnachSupportedBank(bankName: string) {
        const enachSupportedBankNames = this.configService.getEnachSupportedBankNames();
        const bankFound = enachSupportedBankNames.find(bank => bank.toLowerCase() === bankName.toLowerCase());
        return !!bankFound;
    }
}
